export enum QesColors {
  QesPrimaryWhite = "#ffffff",
  QesPrimaryGray1 = "#fbfbff",
  QesPrimaryGray2 = "#f9f9ff",
  QesPrimaryGray3 = "#f2f2fc",
  QesPrimaryGray4 = "#d3d3e9", // blue haze
  QesPrimaryGray5 = "#acacc5", // logan
  QesPrimaryGray6 = "#6e6e8b",
  QesPrimaryGray7 = "#504d5c",
  QesPrimaryGray8 = "#32323c",

  // blues
  QesTertiaryBlue1 = "#4790e6", // cornflower blue
  QesTertiaryBlue4 = "#dcecff", // zumthor-1

  // reds
  QesPrimaryRed = "#cc3a52",
  QesTertiaryRed2 = "#f23957", // amaranth
  QesTertiaryRed4 = "#fcd7dd", // pig pink

  // yellows
  QesTertiaryYellow2 = "#ffd654", // mustard
  QesTertiaryYellow4 = "#fff7dd", // varden

  // purples
  QesTertiaryPurple1 = "#624186", // dark purple
  QesTertiaryPurple2 = "#725191", // medium purple
  QesTertiaryPurple3 = "#A66CDD", // light purple
  QesTertiaryPurple4 = "#7547d7", // vivid purple
  QesTertiaryPurple5 = "#9b83c1", // muted lavender
  QesTertiaryPurple6 = "#c3b8d6", // pale lavender

  // greens
  QesTertiaryGreen2 = "#00cd87", // carribean green
  QesTertiaryGreen4 = "#CCF5E7", // white ice
  QesPrimaryGreen = "#008559",

  // oranges
  QesTertiaryOrange1 = "#e6914c", // porsche
  QesTertiaryOrange2 = "#ffa154", // texas rose
  QesTertiaryOrange3 = "#ffe2cb", // negroni
  QesTertiaryOrange4 = "#ffecdd", // seashell peach

  // New design system push 2026
  // These should all be kept in sync with their scss counterparts in styles/design-system/colors
  Amber50 = "#FFF5EC",
  Amber100 = "#FFE5CE",
  Amber200 = "#FFCDA1",
  Amber300 = "#FFB36B",
  Amber400 = "#FF9631",
  Amber500 = "#EA750C",
  Amber600 = "#D36800",
  Amber700 = "#AE5000",
  Amber800 = "#8D3C00",
  Amber900 = "#6C2B00",
  Amber950 = "#4F1C00",

  Blue50 = "#F0F6FF",
  Blue100 = "#CFE3FF",
  Blue200 = "#9FC7FF",
  Blue300 = "#6AA9FF",
  Blue400 = "#3A8AF3",
  Blue500 = "#056EDF",
  Blue600 = "#005CBF",
  Blue700 = "#00499B",
  Blue800 = "#00397B",
  Blue900 = "#002A5D",
  Blue950 = "#001C44",

  Gray0 = "#FFFFFF",
  Gray50 = "#F7F7F7",
  Gray100 = "#E6E6E6",
  Gray200 = "#D5D6D6",
  Gray300 = "#ACACAD",
  Gray400 = "#828384",
  Gray500 = "#58595B",
  Gray600 = "#404142",
  Gray700 = "#282829",
  Gray800 = "#0F0F0F",

  Green50 = "#F6FCF9",
  Green100 = "#E3F5EC",
  Green200 = "#D0EEE0",
  Green300 = "#A0DCC0",
  Green400 = "#71CBA1",
  Green500 = "#42BA82",
  Green600 = "#3AA171",
  Green700 = "#31875F",
  Green800 = "#286E4D",
  Green900 = "#1E543B",
  Green950 = "#153B29",

  Malibu50 = "#F2FBFD",
  Malibu100 = "#D9F2F9",
  Malibu200 = "#BFE9F5",
  Malibu300 = "#80D2EA",
  Malibu400 = "#40BCE0",
  Malibu500 = "#00A6D6",
  Malibu600 = "#0096BF",
  Malibu700 = "#0082A6",
  Malibu800 = "#006E8C",
  Malibu900 = "#005A73",
  Malibu950 = "#004659",

  Purple50 = "#F7F7FA",
  Purple100 = "#E6E6F0",
  Purple200 = "#D6D5E6",
  Purple300 = "#ADABCD",
  Purple400 = "#8481B5",
  Purple500 = "#5B579C",
  Purple600 = "#4D4982",
  Purple700 = "#3E3B69",
  Purple800 = "#2F2C4F",
  Purple900 = "#201E36",
  Purple950 = "#11101C",

  Red50 = "#FCF5F5",
  Red100 = "#F6E0E0",
  Red200 = "#F0CBCB",
  Red300 = "#E19898",
  Red400 = "#D36464",
  Red500 = "#C43131",
  Red600 = "#B23636",
  Red700 = "#992929",
  Red800 = "#722020",
  Red900 = "#561717",
  Red950 = "#3F1212",

  Yellow50 = "#FFFBF3",
  Yellow100 = "#FFF4DC",
  Yellow200 = "#FEECC4",
  Yellow300 = "#FEDA8A",
  Yellow400 = "#FDC74F",
  Yellow500 = "#FCB415",
  Yellow600 = "#E3A112",
  Yellow700 = "#C98F10",
  Yellow800 = "#B07D0E",
  Yellow900 = "#966B0C",
  Yellow950 = "#7D580A",
}
